import { render, staticRenderFns } from "./SBCategory.html?vue&type=template&id=04c1921a&scoped=true&"
import script from "./SBCategory.ts?vue&type=script&lang=ts&"
export * from "./SBCategory.ts?vue&type=script&lang=ts&"
import style0 from "./SBCategory.css?vue&type=style&index=0&id=04c1921a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c1921a",
  null
  
)

export default component.exports